/* eslint-disable no-undef */
import logo from "../../images/map_icon.png";
import mapLine from "../../images/map_line.png";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const GlobalMap = TMap as any;
let mydom: any;
export function MyInfoWindow(options: any) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  GlobalMap.DOMOverlay.call(this, options);
}
MyInfoWindow.prototype = new GlobalMap.DOMOverlay();

// 初始化
MyInfoWindow.prototype.onInit = function (options: any) {
  this.position = options.position;
  this.content = options.content;
  this.noBackground = options.noBackground;
  this.isMain = options.isMain;
};

// 创建DOM元素，返回一个DOMElement
MyInfoWindow.prototype.createDOM = function () {
  mydom = document.createElement("div");
  if (this.noBackground) {
    //设置DOM样式
    mydom.style.cssText =
      "padding: 8px 10px;\
                    font-size:12px;position:absolute;top:0px;left:0px;border-radius: 30px;";
  } else {
    if (this.isMain) {
      const img = document.createElement("img");
      img.className = "mainIcon";
      img.src = "../../images/shuchenglogo.jpeg";
      mydom.appendChild(img);
      mydom.style.cssText =
        "padding: 8px 10px;background:#00DEFF;border:#00DEFF solid 1px;\
             font-size:16px;font-weight: bold;position:absolute;top:0px;left:0px;border-radius: 30px;";
    } else {
      //设置DOM样式 (经济区的设置)
      mydom.style.cssText =
        "padding: 8px 10px;background:#00DEFF;border:#00DEFF solid 1px;\
               font-size:12px;position:absolute;top:0px;left:0px;border-radius: 30px;";
    }
  }

  mydom.innerHTML = this.content;
  return mydom;
};

MyInfoWindow.prototype.setVisible = function (visible: boolean) {
  if (!this.map) {
    return;
  }
  if (!visible) {
    this.dom.style.display = `none`;
  } else {
    this.dom.style.display = `block`;
  }
};
// 更新DOM元素，在地图移动/缩放后执行
MyInfoWindow.prototype.updateDOM = function () {
  if (!this.map) {
    return;
  }

  // 经纬度坐标转容器像素坐标
  // new globalMap.LatLng(
  //   center.lat,
  //   center.lng
  // )
  // const lat = new this.map.LatLng(this.position.lat, this.position.lng);
  const pixel = this.map.projectToContainer(this.position);
  if (pixel) {
    //默认使用DOM左上角作为坐标焦点进行绘制（左上对齐）
    //如想以DOM中心点（横向&垂直居中）或其它位置为焦点，可结合this.dom.clientWidth和this.dom.clientHeight自行计算
    const left = pixel.getX() - this.dom.clientWidth / 2 + "px"; //本例水平居中
    const top = pixel.getY() - this.dom.clientHeight / 2 + "px";

    //将平面坐标转为三维空间坐标
    this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
  }
};

//自定义一个更新内容的方法
MyInfoWindow.prototype.updateContent = function (content: any) {
  mydom.innerHTML = content;
};

// 以下代码为基于DOMOverlay实现聚合点气泡
export function ClusterBubble(options: any) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  GlobalMap.DOMOverlay.call(this, options);
}

ClusterBubble.prototype = new GlobalMap.DOMOverlay();

ClusterBubble.prototype.onInit = function (options: any) {
  this.content = options.content;
  this.position = options.position;
};

// 销毁时需要删除监听器
ClusterBubble.prototype.onDestroy = function () {
  this.dom.removeEventListener("click", this.onClick);
  this.removeAllListeners();
};

ClusterBubble.prototype.onClick = function () {
  this.emit("click");
};

// 创建气泡DOM元素
ClusterBubble.prototype.createDOM = function () {
  var dom = document.createElement("div");
  // dom.classList.add("clusterBubble");
  const bgColor = "#04a8f1"; //`linear-gradient(90deg, rgba(0, 216, 247, 0) 0%, #00afed 100%)`;
  dom.innerHTML = ` <div style="
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
">
  <div style="
  position: relative;
  ">
      <span style="
        width: 290px;
        height: 21px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 182px;
        border: 2px solid  #0C709D;
        background: ${bgColor};
        border-radius: 20px;
        padding: 2px 16px;
        padding-left: 48px;
        cursor: pointer;
        padding: 4px 8px;
    border-radius: 8px;
      ">${this.content}</span>
  </div>
  <img src=${mapLine} width="30" style="
      position: relative;
      top: -78px;
      height: 33px;
      width: 8px;
  " />
  <img src=${logo} width="30" style="
   position: relative;
    top: -84px;
    width: 22px;
  "/>
</div>`;
  // dom.classList.add("clusterBubble");
  // dom.innerText = this.content;
  // dom.style.cssText = [
  //   // "width: " + (40 + parseInt(this.content) * 2) + "px;",
  //   // "height: " + (40 + parseInt(this.content) * 2) + "px;",
  //   // "line-height: " + (40 + parseInt(this.content) * 2) + "px;",
  // ].join(" ");

  // // 监听点击事件，实现zoomOnClick
  this.onClick = this.onClick.bind(this);
  dom.addEventListener("click", this.onClick);
  // var img1 = document.createElement("img");
  // img1.src = mapLine;
  // img1.classList.add("line");
  // var img2 = document.createElement("img");
  // img2.src = logo;
  // img1.classList.add("logo");
  // dom.appendChild(img1);
  // dom.appendChild(img2);
  return dom;
};

ClusterBubble.prototype.updateDOM = function () {
  if (!this.map) {
    return;
  }
  // 经纬度坐标转容器像素坐标
  let pixel = this.map.projectToContainer(this.position);

  // 使文本框中心点对齐经纬度坐标点
  let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
  let top = pixel.getY() - this.dom.clientHeight / 2 + "px";
  this.dom.style.transform = `translate(${left}, ${top})`;

  this.emit("dom_updated");
};
